
import styled from 'styled-components'
import { suggestiveColor } from '@/style-guide/colors'
import {Networks} from '@/crypto/chain_info/networks';

import {tokenByChainAndAddress} from '@/crypto/chain_info/tokens';

const Line = styled.div`
  border-color: ${suggestiveColor};
  margin: 5px 0;
  display: flex;
  line-height: 20px;
  width: 100%;
`

/**
 * Used when host is setting crypto booking options and picking which networks they want to support
 */
export const CryptoPaymentDetails = ({
    booking
}) => {
    if(!booking) {
        return null;
    }

    const {cryptoPaymentMethod} = booking;
    if(!cryptoPaymentMethod) {
        return null;
    }

    return (
        <Line>
            <div style={{ display: 'flex', gap: '20px' }}>
                <span>
                    Wallet: {cryptoPaymentMethod.wallet}
                </span>
                <span>
                    Network: {Networks[cryptoPaymentMethod.chainId].name}
                </span>
                <span>
                Token: {tokenByChainAndAddress(cryptoPaymentMethod.chainId, cryptoPaymentMethod.token).symbol}
                </span>
            </div>
        </Line>
    )
}